import { render, staticRenderFns } from "./modalDuplicarDescuentoCupones.vue?vue&type=template&id=575e88c8&"
import script from "./modalDuplicarDescuentoCupones.vue?vue&type=script&lang=js&"
export * from "./modalDuplicarDescuentoCupones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports